module.exports = __webpack_public_path__ + "static/media/21.b102b328.png";